export const getModule11FromCodePart = (codePart: string) => {
  const codePartNumbers = codePart.replace(/\D/g, '');

  let totalSum = 0;
  let weight = 2;
  const base = 9;

  codePartNumbers.split('').reverse().forEach((value: string) => {
    totalSum += (parseInt(value, 10) * weight);
    if (weight < base) {
      weight += 1;
      return;
    }
    weight = 2;
  });

  let digit = 11 - (totalSum % 11);
  if (digit > 9) {
    digit = 0;
  }

  return digit.toString();
};

export const validateModule11 = (code: string) => {
  const codeSize = code.length - 1;
  const verifierDigit = code[codeSize];
  let totalSumSuperiorDozenDifference;

  const codeWithoutVerifierDigit = code.slice(0, codeSize);

  const reversedCode = codeWithoutVerifierDigit.split('').reverse();

  let totalSum = 0;

  reversedCode.forEach((value: string, index: number) => {
    totalSum += Number(value) * (2 + (index >= 8 ? index - 8 : index));
  });

  const rest = totalSum % 11;

  switch (rest) {
    case 0:
    case 1:
      totalSumSuperiorDozenDifference = 0;
      break;
    case 10:
      totalSumSuperiorDozenDifference = 1;
      break;
    default:
      totalSumSuperiorDozenDifference = (Math.ceil(totalSum / 11) * 11) - totalSum;
      break;
  }

  return totalSumSuperiorDozenDifference === Number(verifierDigit) ? undefined : 'Módulo 11 inválido';
};



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/validator/validateBarcode/validateModule11/index.ts